//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStore } from '../../store/store';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const eatingHabits = useStore((state) => state.eatingHabits);
  const setEatingHabits = useStore((state) => state.setEatingHabits);

  const [next, setNext] = useState(eatingHabits.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setEatingHabits(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.eatingHabits.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={eatingHabits} onChange={handleChange}>
          <MultiOption value={'Reduce sugar intake'}>
            <span>🍬</span>
            {t('onboarding.eatingHabits.options.sugar')}
          </MultiOption>
          <MultiOption value={'Eat less junk food'}>
            <span>🍔</span>
            {t('onboarding.eatingHabits.options.junkFood')}
          </MultiOption>
          <MultiOption value={'Stop binge eating'}>
            <span>🌭</span>
            {t('onboarding.eatingHabits.options.binge')}
          </MultiOption>
          <MultiOption value={'Eat more greens & vegies'}>
            <span>🥬</span>
            {t('onboarding.eatingHabits.options.vegies')}
          </MultiOption>
          <MultiOption value={'Stop stress overeating'}>
            <span>🍿</span>
            {t('onboarding.eatingHabits.options.overeating')}
          </MultiOption>
          <MultiOption value={'Cook at home more often'}>
            <span>🍲</span>
            {t('onboarding.eatingHabits.options.cookOften')}
          </MultiOption>
          <MultiOption value={'Reduce salt intake'}>
            <span>🧂</span>
            {t('onboarding.eatingHabits.options.salt')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.eatingHabits.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'eating-habits',
              answer: eatingHabits.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
